import { useI18n } from "../lib/i18n";
import { Globe } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";

export default function LanguageSwitcher({ compact = false }) {
  const { lang, setLang, langs } = useI18n();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="lang-switcher"
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-white/10 bg-white/[0.02] text-sm text-zinc-300 hover:text-white hover:border-white/20 transition-colors duration-200"
        >
          <Globe className="w-3.5 h-3.5" />
          <span className="uppercase tracking-widest text-xs font-bold">{lang}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-[#16161D] border border-white/10 text-white min-w-[140px]" align="end">
        {Object.entries(langs).map(([code, label]) => (
          <DropdownMenuItem
            key={code}
            onClick={() => setLang(code)}
            data-testid={`lang-${code}`}
            className={`cursor-pointer ${lang === code ? "text-orange-400" : "text-zinc-300"} hover:bg-white/5 focus:bg-white/5`}
          >
            <span className="uppercase tracking-widest text-[10px] font-bold w-6">{code}</span>
            <span>{label}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
